import { IconButton, IconButtonProps } from '../icon-button'
import { MenuButton, MenuButtonTagProps } from './index'

type IconMenuButtonProps = Omit<MenuButtonTagProps, 'as' | 'children'> & Pick<IconButtonProps, 'icon' | 'size'>

// An IconButton that opens a Menu. MenuButton sets aria-expanded, which shows it as selected while open.
export const IconMenuButton = (props: IconMenuButtonProps) => (
  <MenuButton as={IconButton} {...props}>
    {null}
  </MenuButton>
)
